import React from 'react';
import { Box, Flex, Text, Image, IconButton  } from '@chakra-ui/react';
import ArrowIcon from "../../assets/Arrow.svg"; // Asegúrate de que la ruta es correcta
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ParentProfile = () => {
    const user = useSelector((state) => state.auth.user);

    return (
        <div className='w-full'>
            <div className='w-full flex justify-between items-center gap-2 '>
                <IconButton size='lg' variant="customIconButton" className="text-neutral-400" colorScheme="gray" icon={<FontAwesomeIcon  icon="fa-regular fa-bell" />} />
                <Box
                    w="230px"
                    h="60px"
                    bg="#BAEAE2"
                    borderRadius="16px"
                    position="relative"
                    paddingInline={4}
                >
                    <Flex align="center" justify="space-between" w="100%" h="100%">
                        <Flex direction="column" textAlign="left" justify="center">
                            <Text color="#303030" fontFamily="Manrope" fontSize="14px" fontWeight="600">
                                {user.nombre}
                            </Text>
                            <Text color="#739691" fontFamily="Manrope" fontSize="12px" fontWeight="700">
                                Basic Plan
                            </Text>
                        </Flex>

                        <Image src={ArrowIcon} boxSize="4" alignSelf="center" />
                    </Flex>
                </Box>
            </div>
        </div>
    );
};

export default ParentProfile;